<div [formGroup]="form" class="informate_select_wrapper">
    <mat-label class="font-style" [ngbTooltip]="clampMaterial_tooltip" placement="right" container="body" tooltipClass="custom-tooltip">
        <!-- Clamp Material -->
        {{ 'CLAMP_PAGE.LABELS.CALC_INPUT.CLAMP_MATERIAL' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #clampMaterial_tooltip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.CLAMP_MATERIAL' | transloco }}
        </p>
    </ng-template>
    <!--tool-tip template end-->

    <mat-select
        formControlName="clampMaterial"
        name="clampMaterial"
        class="input-select"
        [class.spinner]="loading"
        [class.select-disable]="enable"
        (selectionChange)="selectClampMaterial($event)"
    >
        <mat-option class="option-list" *ngFor="let x of optionList" [value]="x.clampMaterialId">{{ x.name }}</mat-option>
    </mat-select>
</div>
